import Component from "../qlib/Component";
import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";
import SharedResource from "../qlib/SharedResource";
import Chain from "../qlib/Chain";

/**
 * Manages the FAQ search's state
 * @export
 * @class FAQSearchComponent
 * @extends Component
 */
export default class FAQSearchComponent extends Component
{
    constructor(element)
    {
        super(element)

        this.input_element = element.querySelector('input')

        this.input_element.addEventListener('keyup', () => {
            this.searchValue(this.input_element.value)
        })
    }

    searchValue(value)
    {
        $('.card').addClass('d-none')
        $(`.card:contains('${value}')`).removeClass('d-none')
    }
}

$.expr[":"].contains = $.expr.createPseudo(function(arg) {
    return function( elem ) {
        return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
});

SimpleComponentRegistery.register("faqsearch", FAQSearchComponent)